// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-yVwy","toggleWrap":"styles_toggleWrap__3Uyrc","content":"styles_content__1E8PT","selectAreaCode":"styles_selectAreaCode__3T6cQ"};